import * as Msal from 'msal';

export const AuthApi = (msal: Msal.UserAgentApplication) => ({
  login: () => msal.loginRedirect(), // Fire and forget!
  logout: () => msal.logout() // Fire and forget!
});
